import { z } from 'zod';

import { IdSchema, IsoDateSchema } from './common.js';

const BodyPart = z.number().min(0).max(500).nullable().optional();

export const MeasurementSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  date: IsoDateSchema,
  weight: BodyPart,
  bodyFat: z.number().min(0).max(100).nullable().optional(),
  chest: BodyPart,
  waist: BodyPart,
  hips: BodyPart,
  bicepLeft: BodyPart,
  bicepRight: BodyPart,
  thighLeft: BodyPart,
  thighRight: BodyPart,
  notes: z.string().max(2000).nullable(),
  createdAt: IsoDateSchema,
});
export type Measurement = z.infer<typeof MeasurementSchema>;

export const CreateMeasurementSchema = MeasurementSchema.omit({
  id: true,
  userId: true,
  createdAt: true,
});
export type CreateMeasurementInput = z.infer<typeof CreateMeasurementSchema>;

export const UpdateMeasurementSchema = CreateMeasurementSchema.partial();
export type UpdateMeasurementInput = z.infer<typeof UpdateMeasurementSchema>;
